import { array } from '@ember/helper';
import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import can from 'ember-can/helpers/can';
import { BreadcrumbsItem, LayoutSidebarSubnav } from 'core/components';
import linkToTfcResource from 'core/helpers/link-to-tfc-resource';

<template>
  {{#let (t "components.page.terraform.title") as |title|}}
    {{pageTitle title}}
    <BreadcrumbsItem @icon="terraform" @route="terraform" @text={{title}} />
    <LayoutSidebarSubnav as |Subnav|>
      <Subnav.BackLink
        @text={{t "nav.back-to-cloud-dashboard"}}
        @route="cloud.orgs.detail.projects.detail.index"
        @models={{array
          @controller.model.organization.id
          @controller.model.project.id
        }}
        data-test-terraform-subnav-link-back
      />
      <Subnav.Title data-test-terraform-subnav-title>
        {{t "nav.project.terraform.header"}}
      </Subnav.Title>
      <Subnav.Link
        @route="terraform.index"
        @text={{t "nav.project.terraform.overview"}}
      />
      {{#if @controller.model.unifiedExperienceEnabled}}
        <Subnav.Title data-test-terraform-manage-subnav-title>
          {{t "nav.project.terraform.manage"}}
        </Subnav.Title>

        <Subnav.Link
          data-test-terraform-plan-subnav-link
          @href={{linkToTfcResource
            @controller.deployGeo
            "hashicorp.terraform_cloud.organization:billing-settings"
            @controller.model.organization.name
          }}
          @isHrefExternal={{true}}
          @text={{t "nav.project.terraform.plan.header"}}
        />

        {{#if (can "list terraform-workspaces")}}
          <Subnav.Link
            data-test-terraform-workspaces-subnav-link
            @route="terraform.workspaces"
            @text={{t "nav.project.terraform.workspaces.header"}}
          />
        {{/if}}
      {{/if}}
    </LayoutSidebarSubnav>
    {{outlet}}
  {{/let}}
</template>
